export const getHTML = (html: string | TrustedHTML) => {
  return { __html: html };
};
